module.exports = __webpack_public_path__ + "img/Manual.4fd9c701.svg";